export default function LegalLayout({ eyebrow, title, updated, children }) {
  return (
    <div className="min-h-screen bg-obsidian">
      <header className="glass-panel border-x-0 border-t-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-between h-16 sm:h-20">
          <a href="/" data-testid="legal-brand-link" className="font-serif text-lg sm:text-xl tracking-[0.25em] uppercase text-amber-100/95">
            Monroe <span className="gold-text italic">Society</span>
          </a>
          <a href="/" data-testid="legal-home-link" className="text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-gold transition-colors">
            Return Home
          </a>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-8 py-14 lg:py-20">
        <p className="text-xs uppercase tracking-[0.35em] text-gold/80 mb-4">{eyebrow}</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-light text-amber-100/95 leading-tight mb-3">{title}</h1>
        <p className="text-xs text-neutral-600 mb-12">Last updated: {updated}</p>
        <div className="space-y-10">{children}</div>
      </main>
    </div>
  );
}

export function Section({ num, title, children }) {
  return (
    <section data-testid={`legal-section-${String(num).replace(/\./g, "-")}`} className="border-t hairline-gold pt-8">
      <h2 className="font-serif text-2xl text-amber-100/90 mb-4">
        <span className="gold-text mr-3">{num}.</span>
        {title}
      </h2>
      <div className="space-y-3 text-sm text-neutral-400 font-light leading-relaxed">{children}</div>
    </section>
  );
}
